module.exports = __webpack_public_path__ + "static/media/logo.786ba058.svg";